const baseRoute = 'wormhole-v2';
export const ROUTE_CONSTANTS = {
  HOME: `/:projectId/${baseRoute}/home`,
  LOGIN: `/:projectId/${baseRoute}/login`,
  REGISTER_UTILITY: `/:projectId/${baseRoute}/registerutility`,
  CONNECTIONS: `/:projectId/${baseRoute}/connections`,
  LAYOUT: `/:projectId/${baseRoute}/`,
  USER: `/:projectId/${baseRoute}/user`,
  TASK: `/:projectId/${baseRoute}/task`,
  DATAPIPELINE: `/:projectId/${baseRoute}/data-pipeline`,
  GATEWAY: `/:projectId/${baseRoute}/gateway`,
  LOGS: `/:projectId/${baseRoute}/logs`,
  FORM: `/:projectId/${baseRoute}/form`,
  MASTER: `/:projectId/${baseRoute}/master`,
  CALENDAR: `/:projectId/${baseRoute}/calendar`,
  USERS: `/:projectId/${baseRoute}/users`,
  MANAGEMENT: `/:projectId/${baseRoute}/management`,
  Profile: `/:projectId/${baseRoute}/profile`,
  unstructured_to_structured: `/:projectId/${baseRoute}/unstructured-to-structured`,
  VALIDATE_TASK: `/:projectId/${baseRoute}/validate-task`,
  PROCESS_AUTOMATION: `/:projectId/${baseRoute}/process-automation`,
  WORKSPACELIST:'/workspacelist',
};
